import React, { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { signInActionMessage } from '../../utils/signInActionCopy';

// The result of adding a sign-in method, at the top of the page content once the app is signed in.
// It sits in the page flow, so it never covers the app bar or the page (UX review 2), and stays
// until the user dismisses it. The live region is in the DOM before its text arrives, so screen
// readers announce it; focus stays where it is.
const SignInActionNotice: React.FC = () => {
  const { actionOutcome, dismissActionOutcome } = useAuth();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setMounted(true), 0);
    return () => window.clearTimeout(timer);
  }, []);
  const message = mounted && actionOutcome ? signInActionMessage(actionOutcome) : null;
  return (
    <Box role="status" aria-live="polite" data-testid="sign-in-action-notice">
      {message && (
        // role="none": MUI's Alert defaults to an assertive role="alert"; the wrapper is the only
        // live region.
        <Alert severity={message.severity} role="none" closeText="Dismiss" onClose={dismissActionOutcome} sx={{ mb: 2 }}>
          {message.text}
        </Alert>
      )}
    </Box>
  );
};

export default SignInActionNotice;
